import * as __WEBPACK_EXTERNAL_MODULE_xgplayer__ from "xgplayer";
import * as __WEBPACK_EXTERNAL_MODULE_mpegts_js_26c042fa__ from "mpegts.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
class MpegtsPlugin extends __WEBPACK_EXTERNAL_MODULE_xgplayer__.BasePlugin {
    static get isSupported() {
        return __WEBPACK_EXTERNAL_MODULE_mpegts_js_26c042fa__["default"].isSupported;
    }
    static get pluginName() {
        return "MpegtsPlugin";
    }
    static get defaultConfig() {
        return {
            mediaDataSource: {
                type: "flv"
            },
            mpegtsConfig: {}
        };
    }
    beforePlayerInit() {
        const { url } = this.playerConfig;
        if (url) this.mpegtsLoad(url);
    }
    afterCreate() {
        const { player, playerConfig } = this;
        const media = player.media;
        this.mpegts = null;
        media.addEventListener("contextmenu", function(e) {
            e.preventDefault();
        });
        this.on(__WEBPACK_EXTERNAL_MODULE_xgplayer__.Events.URL_CHANGE, (url)=>{
            if (url.startsWith("blob")) return;
            playerConfig.url = url;
            this.mpegtsLoad(url);
        });
        __WEBPACK_EXTERNAL_MODULE_xgplayer__.BasePlugin.defineGetterOrSetter(player, {
            url: {
                get: ()=>media.src,
                configurable: true
            },
            __url: {
                get: ()=>playerConfig.url
            },
            __mpegts__: {
                get: ()=>this.mpegts
            }
        });
    }
    destroy() {
        if (!this.mpegts) return;
        this.mpegts.unload();
        this.mpegts.detachMediaElement();
        this.mpegts.destroy();
        this.mpegts = null;
    }
    createInstance(mpegts) {
        if (!mpegts) return;
        const { player, playerConfig } = this;
        const media = player.media;
        mpegts.attachMediaElement(media);
        mpegts.load();
        if (playerConfig.autoplay) mpegts.play();
        mpegts.on(__WEBPACK_EXTERNAL_MODULE_mpegts_js_26c042fa__["default"].Events.ERROR, (e)=>{
            player.emit("mpegts_error", `mpegts_error: ${e}, url: ${player.url}`);
        });
        mpegts.on(__WEBPACK_EXTERNAL_MODULE_mpegts_js_26c042fa__["default"].Events.STATISTICS_INFO, (data)=>{
            player.emit("statistics_info", data);
        });
        mpegts.on(__WEBPACK_EXTERNAL_MODULE_mpegts_js_26c042fa__["default"].Events.MEDIA_INFO, (data)=>{
            player.emit("MEDIA_INFO", data);
        });
    }
    mpegtsLoad(url) {
        const { mediaDataSource, mpegtsConfig } = this.config;
        mediaDataSource.url = url;
        mediaDataSource.isLive = this.playerConfig.isLive;
        mediaDataSource.segments = void 0;
        if (void 0 !== this.mpegts) this.destroy();
        this.mpegts = __WEBPACK_EXTERNAL_MODULE_mpegts_js_26c042fa__["default"].createPlayer(mediaDataSource, mpegtsConfig);
        this.createInstance(this.mpegts);
    }
    constructor(...args){
        super(...args), _define_property(this, "mpegts", null);
    }
}
const src = MpegtsPlugin;
var __webpack_exports__Mpegts = __WEBPACK_EXTERNAL_MODULE_mpegts_js_26c042fa__["default"];
export { src as default, __webpack_exports__Mpegts as Mpegts };
